// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"eb4c4317","498":"5a168904","513":"bada8493","787":"cdf0183c"}[chunkId] + ".chunk.js";
};